export default __webpack_public_path__ + "static/media/linda sanchez.30218023.jpg";